import { request } from '../request'

// 获取任务列表
export interface GetResultList {
  limit: number
  page: number
  task_id?: string
  keyword?: string
  start_time?: string
  end_time?: string
  result_status?: string
  biz_area?: string
}
export const getResultList = (data: GetResultList) =>
  request('/portal/verify/containerSecurity/resultList', {
    params: {
      ...data,
    },
  })

//  删除列表
export interface DeleteList {
  result_id_list: string[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/containerSecurity/batchDeleteResult', {
    method: 'delete',
    data,
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/containerSecurity/resultBizAreaList')

//停止任务
export const stopTask = data =>
  request('/portal/v1/container_security/task/stopTask', {
    method: 'post',
    data,
  })

// 任务复测
export const retestTask = data =>
  request('/portal/verify/containerSecurity/taskReExec', {
    method: 'post',
    data,
  })

// 删除主任务
export const deleteTask = (taskIds: string[]) =>
  request('/portal/v1/container_security/tasks', {
    method: 'post',
    data: { taskIds },
  })

// 获取任务执行列表
export const getTaskExecList = (taskId, data) =>
  request(`/portal/v1/container_security/tasks/${taskId}/results`, { params: data })

// 获取任务列表
export const getTaskList = data => request('/portal/v1/container_security/tasks', { params: data })

// 获取任务详情
export const getTaskDetail = (taskId: string) =>
  request(`/portal/v1/container_security/task_detail/${taskId}`)

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/v1/container_security/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/v1/container_security/task_results/${data.resultId}/case/count`, {
    params: {
      ...data,
    },
  })

// 暂停/重启 计划任务
export interface ChangeJobStatus {
  taskId: string
  task_status?: number
}
export const changeJobStatus = (data: ChangeJobStatus) =>
  request('/portal/verify/containerSecurity/changeJobStatus', {
    method: 'PUT',
    data,
  })

// 暂停计划任务
export const changeJobPause = (data: ChangeJobStatus) =>
  request('/portal/v1/container_security/task/pause', {
    method: 'POST',
    data,
  })
// 开启计划任务
export const changeJobStart = (data: ChangeJobStatus) =>
  request('/portal/v1/container_security/task/start', {
    method: 'POST',
    data,
  })

// 获取分组列表
export const getGroupList = () => request('/portal/v1/container_security/task_results/group_list')

// 获取安全设备列表
export const getSecurityDeviceList = () => request('/portal/v1/container_security/task/deviceList')

// 获取目标主体
export const getSecurityTarget = () => request('/portal/v1/container_security/host/list')

// 获取任务详情模板列表
export const getTaskDetailTemplateList = data =>
  request(`/portal/v1/container_security/tasks/${data.taskId}/templateList`, {
    params: {
      ...data,
    },
  })

// 获取任务详情用例列表
export const getTaskDetailCaseList = data =>
  request(
    `/portal/v1/container_security/tasks/${data.taskId}/template/${data.templateId}/caseList`,
    {
      params: {
        ...data,
      },
    },
  )

// 获取任务详情用例攻击类型列表
export const getTaskDetailCaseAttackType = data =>
  request(
    `/portal/v1/container_security/tasks/${data.taskId}/template/${data.templateId}/caseAttackList`,
  )

// 获取用例详情
export const getCaseDetail = data =>
  request(`/portal/verify/containerSecurity/pluginDetail`, {
    params: {
      ...data,
    },
  })
